export interface LobbyEls {
  lobby: HTMLElement;
  choice: HTMLElement;
  hosting: HTMLElement;
  joining: HTMLElement;
  game: HTMLElement;
  btnHost: HTMLButtonElement;
  btnJoin: HTMLButtonElement;
  btnBot: HTMLButtonElement;
  botDifficulty: HTMLSelectElement;
  mode: HTMLSelectElement;
  joinCode: HTMLInputElement;
  roomCode: HTMLElement;
  btnCopy: HTMLButtonElement;
  hostingStatus: HTMLElement;
  btnCancelHost: HTMLButtonElement;
  joiningStatus: HTMLElement;
  btnCancelJoin: HTMLButtonElement;
  canvas: HTMLCanvasElement;
  stage: HTMLElement;
  rolePill: HTMLElement;
  fpsPill: HTMLElement;
  netPill: HTMLElement;
}

export function grabEls(): LobbyEls {
  // `as unknown as T` because HTMLSelectElement's signature is a
  // structural sibling of HTMLElement, not a subtype (remove() overload
  // mismatch). Going through unknown avoids the lint error without
  // sacrificing the runtime null check.
  const get = <T>(id: string): T => {
    const el = document.getElementById(id);
    if (!el) throw new Error(`missing #${id}`);
    return el as unknown as T;
  };
  return {
    lobby: get('lobby'),
    choice: get('lobby-choice'),
    hosting: get('lobby-hosting'),
    joining: get('lobby-joining'),
    game: get('game'),
    btnHost: get('btn-host'),
    btnJoin: get('btn-join'),
    btnBot: get('btn-bot'),
    botDifficulty: get<HTMLSelectElement>('bot-difficulty'),
    mode: get<HTMLSelectElement>('mode'),
    joinCode: get('join-code'),
    roomCode: get('room-code'),
    btnCopy: get('btn-copy'),
    hostingStatus: get('hosting-status'),
    btnCancelHost: get('btn-cancel-host'),
    joiningStatus: get('joining-status'),
    btnCancelJoin: get('btn-cancel-join'),
    canvas: get<HTMLCanvasElement>('canvas'),
    stage: get('stage'),
    rolePill: get('role-pill'),
    fpsPill: get('fps-pill'),
    netPill: get('net-pill'),
  };
}

export function showLobbyChoice(els: LobbyEls): void {
  els.lobby.classList.remove('hidden');
  els.game.classList.add('hidden');
  els.choice.classList.remove('hidden');
  els.hosting.classList.add('hidden');
  els.joining.classList.add('hidden');
}

export function showHosting(els: LobbyEls, code: string): void {
  els.choice.classList.add('hidden');
  els.hosting.classList.remove('hidden');
  els.joining.classList.add('hidden');
  els.roomCode.textContent = code;
}

export function showJoining(els: LobbyEls): void {
  els.choice.classList.add('hidden');
  els.hosting.classList.add('hidden');
  els.joining.classList.remove('hidden');
}

export function showGame(els: LobbyEls, role: 'host' | 'guest', vsBot = false): void {
  els.lobby.classList.add('hidden');
  els.game.classList.remove('hidden');
  const youLabel = role === 'host' ? 'YOU · PINK' : 'YOU · CYAN';
  els.rolePill.textContent = vsBot ? `${youLabel} · vs BOT` : youLabel;
}

export function readJoinCodeFromHash(): string | null {
  const m = location.hash.match(/^#join=([A-Z0-9]{6})$/i);
  return m ? m[1]!.toUpperCase() : null;
}

export function buildShareLink(code: string): string {
  return `${location.origin}/#join=${code}`;
}
